
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChevronDoubleUpGoogle as ObiChevronDoubleUpGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chevron-double-up-google.js';
 
 
 

 
 export const ObiChevronDoubleUpGoogle = createComponent({
   react: React,
   tagName: 'obi-chevron-double-up-google',
   elementClass: ObiChevronDoubleUpGoogleElement,
   events: {
     
   }
  });
 
 